// latest: zhangmyh 2017-8-14 4:22 PM
/* global $ u ko */
import 'components/filesupload'
let _model
function init (refer) {
  let enterpriseId = refer.options.enterpriseId || window.global.user.enterpriseId
  let vm = {
    enterpriseId: ko.observable(enterpriseId),
    model: _model,
    getFontColor: function () {
      let status = _model.getValue('status')
      return status
    }
  }
  let app = u.createApp()
  app.init(vm, $('#showChangeInfo')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qxchange/view/index.js